import React from "react";
import PropTypes from "prop-types";
import { easilGrayXDark } from "./style.module.css";

const MuteIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 20}
    height={height || size || 20}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
  >
    <g fill="none" fill-rule="evenodd">
      <rect width="20" height="20" rx="4" />
      <path d="M3 3h14v14H3z" />
      <path
        d="M5 7.5h1.5L10 5v10l-3.5-2.5H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1z"
        stroke={color || easilGrayXDark}
        stroke-width="1.9"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <g
        stroke={color || easilGrayXDark}
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.7"
      >
        <path d="m13 8 3 4M16 8l-3 4" />
      </g>
    </g>
  </svg>
);
MuteIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default MuteIcon;
